<template>
  <div>
    <div class="endCheer" v-if="canRend">
      <div class="poster">
        <div class="header" v-if="isH5Title">
          <div class="icon" @click="closeWeb">
            <img
              src="https://static-vip.sports.cctv.com/cctv-vip/pc/20210511/icon_back@3x.png"
              alt=""
            />
          </div>
          <div class="title">
            助力全运会 为家乡助威加油
          </div>
        </div>
        <!-- 底图 -->
        <img src="https://images.zhibo.tv/2021/0907/header_2x.png" alt="" />
      </div>
      <div class="mainBox">
        <!-- 省市代表团 -->
        <div class="areaBox">
          <div class="titleImg">
            助威排行榜
          </div>
          <div class="block"></div>
          <div class="topList">
            <div class="top2Box">
              <div class="top2">
                <img mode="scaleToFill" :src="areaList[1].icon" />
              </div>
              <div class="name">
                {{ areaList[1].legion_name }}
              </div>
              <div class="cheerValue">{{ areaList[1].power_value }}助威值</div>
            </div>
            <div class="top1Box">
              <div class="top1">
                <img mode="scaleToFill" :src="areaList[0].icon" />
              </div>
              <div class="name">
                {{ areaList[0].legion_name }}
              </div>
              <div class="cheerValue">{{ areaList[0].power_value }}助威值</div>
            </div>
            <div class="top3Box">
              <div class="top3">
                <img mode="scaleToFill" :src="areaList[2].icon" />
              </div>
              <div class="name">
                {{ areaList[2].legion_name }}
              </div>
              <div class="cheerValue">{{ areaList[2].power_value }}助威值</div>
            </div>
          </div>
          <div class="areaList">
            <div
              class="areaItem"
              v-for="(item, index) in areaList.slice(3, 10)"
              :key="index"
            >
              <div class="rank">{{ index + 4 }}</div>
              <div class="icon"><img :src="item.icon" alt="" /></div>
              <div class="name">{{ item.legion_name }}</div>
              <div class="centerInfo">
                <div class="progress">
                  <div class="progressBar" v-if="false">
                    <div
                      class="value"
                      :style="{ width: item.hot_value * 100 + '%' }"
                    ></div>
                  </div>
                  <div class="num">{{ item.power_value }}助力值</div>
                </div>
              </div>
            </div>
          </div>
          <!-- 遮罩 -->
          <div class="cover"></div>
        </div>
        <!-- 数据统计 -->
        <div class="totalData" v-if="false">
          2021年陕西全运会<br />
          全网共计有<span>{{ totalNum }}次</span>为家乡助威加油<br />
          有<span>{{ getSkinNum }}人</span>获得盲盒奖励<br />
        </div>
        <!-- 用户信息 -->
        <div class="userInfo">
          <div class="userInfoBox">
            <div class="userHead">
              <img
                mode="aspectFill"
                :src="
                  userInfo.head_img && token
                    ? userInfo.head_img
                    : 'https://images.zhibo.tv/2021/0909/img_header_3x.png'
                "
              />>
            </div>
            <div class="userName">
              {{ userInfo.nickname && token ? userInfo.nickname : '未登录' }}
            </div>
            <div class="myInfo" v-if="powerLogs.length && token">
              为
              <span v-for="(item, index) in powerLogs" :key="index">
                {{ item.legion_name }}助威{{ item.num }}次{{
                  index != powerLogs.length - 1 ? '、' : ''
                }}
              </span>
              <div>获得了{{ rewardList.length }}个皮肤奖励</div>
            </div>
            <div class="myInfo" v-if="!powerLogs.length && token">
              无助威记录
            </div>
            <div class="nologin" v-if="!token" @click="phoneLogin">
              请登录后查看
            </div>
          </div>
        </div>
        <!-- 我的奖励 -->
        <div class="myReward" v-if="!isShare && token">
          <div class="titleImg">
            我的奖励
          </div>
          <div class="myRewardList" v-if="rewardList.length">
            <div
              class="myRewardItem"
              v-for="(item, index) in rewardList"
              :key="index"
            >
              <div class="rank">{{ index + 1 }}</div>
              <div class="name" v-if="item.power_num !== '100'">
                累计助威{{ item.power_num }}次奖励
              </div>
              <div class="name" v-else>终极付款码奖励</div>
              <div class="see" @click="seeReward(item)">查看</div>
            </div>
          </div>
          <!-- 无数据 -->
          <div class="nodata" v-else>
            无记录
          </div>
        </div>
        <!-- 保存 -->
        <div class="saveBtn" @click="toSave" v-if="powerLogs.length">
          <img src="https://images.zhibo.tv/2021/0905/btn_save_2x.png" alt="" />
        </div>
      </div>
      <div class="cheerDialog" v-if="dialogBox1IsShow">
        <div class="dialogBox1">
          <!-- 关闭按钮 -->
          <div class="icon_close" @click="handleClose">
            <img
              src="https://images.zhibo.tv/2021/0905/icon_close_2x.png"
              alt=""
            />
          </div>
          <!-- 弹窗-助威成功未中奖 -->
          <div class="title">
            {{ !isWin ? '助威成功' : '恭喜您' }}
          </div>
          <div class="info" v-if="!isWin">
            <!-- {{nextNum?`助威成功，获得一次抽奖机会，再助威${nextNum}次，可获得专属付款码皮肤.`:''}} -->
            可获得一个盲盒奖励
          </div>
          <div class="info" v-else>恭喜您，获得{{ winName }}</div>
          <div class="btn" @click="handleBtn">
            <img src="https://images.zhibo.tv/2021/0907/btn_yes.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <upload></upload>
    </div>
    <!-- <publicFooter v-if="isApp && isShare"></publicFooter> -->
  </div>
</template>

<script>
import upload from '../../components/Upload.vue'
// import publicFooter from '../../components/PublicFooter.vue'
export default {
  name: '',
  data() {
    return {
      token: '',
      platform: 'h5',
      statistics: '',
      activityId: '',
      // 我的奖励
      rewardList: [],
      powerLogs: [],
      // 省市代表团
      areaList: [],
      totalNum: '',
      getSkinNum: '',
      userInfo: '',
      dialogBox1IsShow: false,
      // 是否展示标题
      isH5Title: true,
      canRend: false,
      // 是否是分享
      isShare: false,
      isApp: false
    }
  },
  //components: { upload, publicFooter },
  components: { upload},
  computed: {},
  watch: {},
  created() {
    this.changeTitle()
    this.changeStatusbar('#08A05E', 1)
    this.getInfo()
  },
  methods: {
    // 获取token
    getInfo() {
      this.token = this.getcommit('token') || ''
      this.statistics = this.getcommit('statistics') || ''
      this.isH5Title = this.getcommit('isH5Title') ? true : false
      this.isShare = this.getcommit('isShare') ? true : false
      this.getActivity()
    },
    // 获取url上的信息
    getcommit(name) {
      return (
        decodeURIComponent(
          (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
            location.href
          ) || ['', ''])[1].replace(/\+/g, '%20')
        ) || false
      )
    },
    // 获取助威活动信息
    async getActivity() {
      let params = {
        activityId: 1,
        platform: this.platform,
        token: this.token
      }
      let res = await this.$api.getActivity(params)
      window.console.log(res)
      this.rule = res.data.data.h5_rule
      this.activityId = res.data.data.activity_id
      this.getAreaList()
      // 如果登录，获取用户助威信息
      if (this.token) {
        this.getUserCheerInfo()
      }
      this.getActivityData()
    },
    // 获取省市代表团
    async getAreaList() {
      let params = {
        activityId: this.activityId
      }
      let res = await this.$api.getAreaList(params)
      window.console.log(res)
      this.areaList = res.data.data
      this.canRend = true
    },
    //获取用户助力数据
    async getUserCheerInfo() {
      let params = {
        activityId: this.activityId,
        platform: this.platform,
        token: this.token
      }
      let res = await this.$api.getUserCheerInfo(params)
      window.console.log(res)
    },
    // 获取统计数据
    async getActivityData() {
      let params = {
        activityId: this.activityId,
        platform: this.platform,
        token: this.token
      }
      let res = await this.$api.getActivityData(params)
      window.console.log(res)

      this.totalNum = res.data.data.activity.total_power_num
      this.getSkinNum = res.data.data.activity.alipay_prize_num
      this.userInfo = res.data.data.user_data
      this.powerLogs = res.data.data.power_logs
      this.rewardList = res.data.data.user_prizes
    },
    // 查看我的奖励
    seeReward(item) {
      window.console.log(item)
      this.isWin = true
      this.winName = item.prize_name
      this.dialogBox1IsShow = true
    },
    // 点击确定
    handleBtn() {
      this.dialogBox1IsShow = false
      window.location.reload()
    },
    // 关闭弹窗
    handleClose() {
      this.dialogBox1IsShow = false
    },
    // 保存
    toSave() {
      this.shareUrl =
        'https://' +
        this.LoginURL() +
        'static.zhibo.tv/specialtopic/endcheer?isShare=1&token=' +
        this.token
      this.shareImg = 'https://images.zhibo.tv/2021/0909/share@3x.png'
      this.shareTitle = `中国体育 全运会，我为家乡助威加油`
      this.shareParams = {
        title: this.shareTitle,
        imageUrl: this.shareImg,
        jumpUrl: this.shareUrl
      }
      this.gotoAPPShare()
    },
    // 调用两端分享
    gotoAPPShare() {
      // 两端的分享方法
      try {
        window.webkit.messageHandlers.share.postMessage(this.shareParams)
      } catch (e) {
        window.console.log('ios调用分享失败2', this.shareParams)
      }
      try {
        window.LiveAppJS.share(this.shareTitle, this.shareImg, this.shareUrl)
      } catch (e) {
        window.console.log(
          'Android调用分享失败2',
          this.shareTitle,
          this.shareImg,
          this.shareUrl
        )
      }
    },
    // 域名获取
    LoginURL() {
      var localDomain = window.location.host
      var name = localDomain.split('.', 2)[0]
      var arr = name.split('-', 2)
      return arr.length > 1 ? arr[0] + '-' : ''
    },
    // 两端的登录方法
    phoneLogin() {
      // 安卓登录
      try {
        window.LiveAppJS.login()
      } catch (e) {
        window.console.log('android login error')
      }
      // IOS登录
      try {
        window.webkit.messageHandlers.isnotlogin.postMessage('login')
      } catch (e) {
        window.console.log('ios login error')
      }
    },
    // 两端打开新页面
    jumpWeb(androidParam, iosParam) {
      try {
        window.webkit.messageHandlers.jumpWeb.postMessage(iosParam)
      } catch (e) {
        window.console.log('IOS跳转失败', iosParam)
      }
      try {
        window.LiveAppJS.jumpWeb(androidParam)
      } catch (e) {
        window.console.log('安卓跳转失败', androidParam)
      }
    },
    // 关闭容器
    closeWeb() {
      var params = 'close'
      try {
        window.webkit.messageHandlers.closeLayer.postMessage(params)
      } catch (e) {
        window.console.log('ios关闭失败')
      }
      try {
        window.LiveAppJS.closeLayer(params)
      } catch (e) {
        window.console.log('Android关闭失败')
      }
    },
    // 两端修改状态栏的方法
    changeStatusbar(bgcolor, wordcolor) {
      var iosParam = {
        bgcolor: bgcolor,
        wordcolor: wordcolor
      }
      try {
        window.webkit.messageHandlers.changeStatusbar.postMessage(iosParam)
      } catch (e) {
        window.console.log('ios修改状态栏颜色失败', iosParam)
      }

      try {
        window.LiveAppJS.changeStatusbar(bgcolor, wordcolor)
      } catch (e) {
        window.console.log('安卓修改状态栏颜色失败', bgcolor, wordcolor)
      }
    },
    // 修改两端标题
    changeTitle() {
      document.title = '助力全运会 为家乡助威加油'
      try {
        window.webkit.messageHandlers.changeTitle.postMessage(
          '助力全运会 为家乡助威加油'
        )
      } catch (e) {
        window.console.log(e)
      }

      try {
        window.LiveAppJS.changeTitle('助力全运会 为家乡助威加油')
      } catch (e) {
        window.console.log(e)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.endCheer {
  max-width: 750px;
  min-height: 100vh;

  margin: 0 auto;
  .titleImg {
    width: 4.6rem;
    height: 0.8rem;
    background: url('https://images.zhibo.tv/2021/0902/bg_title_2x.png')
      no-repeat center;
    background-size: 100%;
    font-size: 0.32rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    position: absolute;
    left: 1.29rem;
    top: -0.08rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .poster {
    width: 100%;
    height: 7.62rem;
    position: relative;
    background: #08a05e;
    .header {
      display: flex;
      align-items: center;
      position: absolute;
      height: 0.88rem;
      .icon {
        width: 0.2rem;
        height: 0.36rem;
        margin-left: 0.3rem;
        margin-right: 1.2rem;
        img {
          display: block;
          width: 0.2rem;
          height: 0.36rem;
        }
      }
      .title {
        font-size: 0.34rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
      }
    }
    img {
      width: 100%;
      height: 7.62rem;
      display: block;
    }
  }
  .mainBox {
    background: linear-gradient(180deg, #3d6da8 43%, #6d5a99 69%);
    border-radius: 0.06rem;
    margin-top: -2rem;
    overflow: hidden;
    position: relative;
    padding-top: 0.6rem;
    // 省市代表团
    .areaBox {
      position: relative;
      width: 7.18rem;
      height: 10.88rem;
      margin: 0 auto;
      margin-bottom: 0.6rem;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 0.1rem;
      .block {
        height: 1.2rem;
      }
      .topList {
        display: flex;
        justify-content: space-between;
        margin-bottom: 0.6rem;
        margin-left: 0.8rem;
        margin-right: 0.8rem;
      }
      .top1Box {
        // margin: 0 0.9rem;
      }
      .top1Box,
      .top2Box,
      .top3Box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
      .name {
        margin-top: 0.18rem;
        font-size: 0.28rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 0.4rem;
        text-shadow: 0 0.02rem 0.15rem #001c60;
      }
      .cheerValue {
        margin-top: 0.18rem;
        font-size: 0.22rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #f5a623;
        line-height: 0.3rem;
      }
      .top1 {
        width: 1.18rem;
        height: 1.18rem;
        /* overflow: hidden; */
        border-radius: 50%;
        background: #ffffff;
        border: 0.04rem solid #fad961;
        position: relative;
      }
      .top1::after {
        content: '';
        display: block;
        position: absolute;
        bottom: -0.15rem;
        width: 0.48rem;
        height: 0.5rem;
        background: url('https://images.zhibo.tv/2021/0913/1_3x.png')
          no-repeat center;
        background-size: 100%;
      }
      .top1 img {
        width: 1.18rem;
        height: 1.18rem;
        display: block;
      }
      .top2 {
        width: 1rem;
        height: 1rem;
        margin-top: 0.2rem;
        border-radius: 50%;
        /* overflow: hidden; */
        background: #ffffff;
        border: 0.03rem solid #afafaf;
        position: relative;
      }
      .top2::after {
        content: '';
        display: block;
        position: absolute;
        bottom: -0.15rem;
        width: 0.38rem;
        height: 0.4rem;
        background: url('https://images.zhibo.tv/2021/0918/top2_3x.png')
          no-repeat center;
        background-size: 100%;
      }
      .top2 img {
        width: 1rem;
        height: 1rem;
        display: block;
      }
      .top3 {
        width: 1rem;
        height: 1rem;
        /* overflow: hidden; */
        margin-top: 0.2rem;
        border-radius: 50%;
        background: #ffffff;
        border: 0.03rem solid #d1ae76;
        position: relative;
      }
      .top3::after {
        content: '';
        display: block;
        position: absolute;
        bottom: -0.15rem;
        width: 0.38rem;
        height: 0.4rem;
        background: url('https://images.zhibo.tv/2021/0918/top3_3x.png')
          no-repeat center;
        background-size: 100%;
      }
      .top3 img {
        width: 1rem;
        height: 1rem;
        display: block;
      }
      .areaList {
        // height: 9.78rem;
        padding: 0 0 0.1rem 0rem;
        overflow-y: scroll;
        position: relative;
        &::-webkit-scrollbar {
          display: none; /* Chrome Safari */
        }
        .areaItem {
          height: 1rem;
          margin-left: 0.4rem;
          margin-right: 0.8rem;
          margin-bottom: 0.5rem;
          display: flex;
          align-items: center;
          // justify-content: center;
          justify-content: space-between;
          .rank {
            width: 0.16rem;
            white-space: nowrap;
            font-size: 0.3rem;
            font-family: BebasNeue;
            color: rgba(255, 255, 255, 0.6);
          }
          .icon {
            width: 1rem;
            height: 1rem;
            border-radius: 50%;
            overflow: hidden;
            margin-left: 0.4rem;
            flex-shrink: 0;
            img {
              display: block;
              width: 1rem;
              height: 1rem;
            }
          }
          .name {
            flex: 1;
            flex-shrink: 0;
            width: 0.9rem;
            margin: 0 0.3rem 0 0.4rem;
            font-size: 0.28rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 0.4rem;
            text-shadow: 0 0.02rem 0.15rem rgba(0, 0, 0, 0.5);
          }
          .centerInfo {
            flex-shrink: 0;
            .progress {
              display: flex;
              align-items: center;
              .progressBar {
                width: 1.96rem;
                height: 0.1rem;
                background: #001956;
                .value {
                  height: 0.1rem;
                  background: linear-gradient(255deg, #ff7204 0%, #c30000 100%);
                }
              }
              .num {
                flex: 1;
                margin-left: 0.3rem;
                font-size: 0.22rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #f5a623;
              }
            }
          }

          .btn {
            width: 1.42rem;
            height: 0.66rem;
            img {
              display: block;
              width: 1.42rem;
              height: 0.66rem;
            }
          }
        }
      }
      .cover {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1.54rem;
        background: linear-gradient(
          180deg,
          rgba(84, 100, 161, 0) 0%,
          #5364a1 100%
        );
        border-radius: 0.1rem;
      }
    }
    .totalData {
      width: 5.13rem;
      // height: 1.5rem;
      margin: 0.8rem auto;
      text-align: center;
      font-size: 0.28rem;
      font-family: godness;
      font-weight: normal;
      color: #ffffff;
      line-height: 0.5rem;
    }

    .totalData span {
      color: rgba(245, 166, 35, 1);
    }
    .userInfo {
      width: 7.18rem;
      min-height: 4.02rem;
      margin: 0 auto;
      position: relative;
      overflow: hidden;
      margin-bottom: 0.6rem;
    }

    .userInfo .userInfoBox {
      width: 7.18rem;
      min-height: 3.42rem;
      margin-top: 0.6rem;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 0.1rem;
      position: relative;
      box-sizing: border-box;
      padding-top: 0.8rem;
      padding-bottom: 0.5rem;
    }

    .userInfo .userInfoBox .userHead {
      width: 1.2rem;
      height: 1.2rem;
      border-radius: 50%;
      box-shadow: 0 0.06rem 0.26rem 0 rgba(10, 20, 51, 0.42);
      border: 0.04rem solid rgba(255, 255, 255, 0.2);
      overflow: hidden;
      position: absolute;
      top: -0.6rem;
      left: 3rem;
    }

    .userInfo .userInfoBox .userHead img {
      display: block;
      width: 1.2rem;
      height: 1.2rem;
    }

    .userInfo .userInfoBox .userName {
      text-align: center;
      font-size: 0.24rem;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(255, 255, 255, 0.8);
      line-height: 0.32rem;
    }

    .userInfo .userInfoBox .myInfo {
      width: 6.6rem;
      min-height: 1.1rem;
      margin: 0 auto;
      margin-top: 0.6rem;
      position: relative;
      font-size: 0.28rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 0.5rem;
      text-align: center;
    }
    .nologin {
      width: 6.6rem;
      min-height: 1.1rem;
      margin: 0 auto;
      margin-top: 0.6rem;
      position: relative;
      font-size: 0.28rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #bdff7a;
      line-height: 0.5rem;
      text-align: center;
    }
    .userInfo .userInfoBox .myInfo::before {
      content: '';
      display: block;
      width: 0.32rem;
      height: 0.2rem;
      background: url('https://images.zhibo.tv/2021/0905/icon_piont_2x.png')
        no-repeat center;
      background-size: 100%;
      position: absolute;
      top: -0.2rem;
      left: -0.09rem;
    }

    .userInfo .userInfoBox .myInfo::after {
      content: '';
      display: block;
      width: 0.32rem;
      height: 0.2rem;
      background: url('https://images.zhibo.tv/2021/0905/icon_piont_2x.png')
        no-repeat center;
      background-size: 100%;
      position: absolute;
      bottom: -0.2rem;
      right: -0.06rem;
    }

    // 我的奖励
    .myReward {
      position: relative;
      width: 7.18rem;
      min-height: 3.66rem;
      margin: 0 auto;
      margin-bottom: 0.6rem;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 0.1rem;
      font-size: 0.24rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #bdff7a;
      line-height: 0.32rem;
      .myRewardList {
        padding: 1.2rem 0.5rem 0 0.5rem;
        .myRewardItem {
          padding-bottom: 0.5rem;
          display: flex;
          justify-content: space-between;
        }
      }
      .nodata {
        text-align: center;
        padding: 1.2rem 0.5rem 0.5rem 0.5rem;
        min-height: 3.66rem;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    // 保存按钮
    .saveBtn {
      width: 4.78rem;
      height: 1.06rem;
      margin: 0 auto;
      margin-bottom: 0.88rem;
      img {
        display: block;
        width: 4.78rem;
        height: 1.06rem;
      }
    }
  }
  // 弹窗
  .cheerDialog {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    .icon_close {
      position: absolute;
      width: 0.32rem;
      height: 0.32rem;
      top: 0.32rem;
      right: 0.32rem;
      img {
        display: block;
        width: 0.32rem;
        height: 0.32rem;
      }
    }
    .title {
      margin-top: 0.4rem;
      margin-bottom: 0.7rem;
      text-align: center;
      height: 0.7rem;
      font-size: 0.34rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
    }
    .info {
      text-align: center;
      padding: 0 0.4rem;
      font-size: 0.28rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 0.4rem;
    }
    .dialogBox1 {
      width: 6.2rem;
      height: 4.14rem;
      background: linear-gradient(135deg, #3d6da8 43%, #6d5a99 69%);
      border-radius: 0.1rem;
      position: relative;
      .title {
        margin-bottom: 1rem;
      }
      .btn {
        width: 2.78rem;
        height: 1.06rem;
        position: absolute;
        bottom: -0.53rem;
        left: 1.71rem;
        img {
          display: block;
          width: 2.78rem;
          height: 1.06rem;
        }
      }
    }
    .dialogBox2 {
      width: 6.2rem;
      height: 5.48rem;
      background: linear-gradient(135deg, #3d6da8 43%, #6d5a99 69%);
      border-radius: 0.1rem;
      position: relative;
      .info {
        img {
          display: block;
          width: 2rem;
          height: 2rem;
          margin: 0 auto;
          margin-top: 0.6rem;
        }
      }
      .btn {
        width: 3.38rem;
        height: 1.06rem;
        position: absolute;
        bottom: -0.53rem;
        left: 1.41rem;
        img {
          display: block;
          width: 3.38rem;
          height: 1.06rem;
        }
      }
    }
  }
}
</style>
